export default {
  explore: {
    filters: 'Filtros',
    resetFilters: 'Restaurar Filtros',
    addKeyword: 'Adicionar palavra-chave',
  },
  recipe: {
    contributedBy: 'Contribuição por',
    ingredients: 'Ingredientes',
    directions: 'Modo de preparo',
    fullRecipe: 'Visualizar receita completa em',
    similarDrinks: 'Bebidas semelhantes',
  },
  featuredRecipes: {
    loadMore: 'Ver mais',
  },
  recipeFind: {
    filterBy: 'Filtrar por',
    name: 'Nome',
    ingredients: 'Ingredientes',
    keywords: 'Palavra-chave',
    searchForIngredients: 'Você pode buscar por múltiplos ingredientes separando-os com um espaço',
    searchForKeywords: 'Você pode buscar por múltiplas palavras-chave separando-as com um espaço',
  },
  recipeList: {
    viewRecipe: 'Ver receita',
  },
  recipeToolbar: {
    print: 'Imprimir',
    share: 'Compartilhar',
    shareOnFacebook: 'Compartilhar no Facebook',
    shareOnTwitter: 'Compartilhar no Twitter',
    copyURL: 'Copiar URL',
    hideImage: 'Esconder imagem',
  },
  favorites: {
    removeAllFavorites: 'Remover todos os favoritos',
    noFavoriteDrinks: 'Você não possui nenhum drink favorito',
    removeFavoritesPrompt: 'Você tem certeza que quer remover todos os favoritos',
    delete: 'Deletar',
    cancel: 'Cancelar',
  },
  keywordList: {
    enterYourKeyword: 'Insira sua palavra-chave',
  },
  search: {
    findYourDrink: 'Encontre sua bebida',
  },
  pageNotFound: {
    pageNotFound: 'A página procurada não foi encontrada.',
    backToHome: 'Voltar para página inicial',
  },
};
